package com.kinoshazam.screens.main.expanded

import androidx.compose.runtime.Composable
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState
import presentation.screens.main.MainViewModel

@Composable
actual fun ExpandedMainWindow(
    state: MainState,
    onAction: (MainMVIAction) -> Unit
) {
}